const TUTORIAL_KEY = 'Sawtna_tutorial_completed';

export function isTutorialCompleted() {
  try {
    return localStorage.getItem(TUTORIAL_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markTutorialCompleted() {
  try {
    localStorage.setItem(TUTORIAL_KEY, 'true');
  } catch {
    // ignore storage errors
  }
}

export const TUTORIAL_SLIDE_COUNT = 9;

export function getPostLoginRoute() {
  return isTutorialCompleted() ? '/patients' : '/onboarding';
}
